import _ from 'lodash'
import Constants from '@/utils/Constants'

export const isStoreAnalysis = () => {
  const storeRestriction = Constants.getSite('store_restriction_flag')
  if (storeRestriction === '0') {
    return true
  }
  const division = Constants.getContract('division')
  if (_.includes([1, 2], division)) {
    return Constants.getUser('store_analysis_flag') === 1
  } else {
    return Constants.getContract('store_analysis_flag') === 1
  }
}
